import NewDeliveryOrder from "../../../../components/@documents/delivery_orders/NewDeliveryOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function DeliveryOrderNewPage() {

    return (
        <NewDeliveryOrder 
            routeType={routeTypes.admin}
        />
    )
}